import type { DatasetDeleteOptions } from "./dataset-delete.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useDatasetDelete = (
  datasetId: number,
  options?: DatasetDeleteOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const { mutate, status, isPending } = useMutation<ApiEmptyResponse, ApiError>(
    {
      mutationKey: ["datasets", "delete", datasetId],
      mutationFn: () => client.datasets.destroy(datasetId),
      onSuccess,
    }
  );

  return {
    deleteDataset: mutate,
    status,
    isPending,
  };
};
